import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import {SearchWidgetCopy} from "@models/cms/search-widget.model";

@Component({
  selector: 'app-traveler-picker-modal-submit-button',
  standalone: true,
  imports: [],
  templateUrl: './traveler-picker-modal-submit-button.component.html',
  styleUrl: './traveler-picker-modal-submit-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TravelerPickerModalSubmitButtonComponent {
  @Input() cmsSearchWidgetCopy: SearchWidgetCopy;
  @Output() onSubmit = new EventEmitter<void>();

  submit() {
    this.onSubmit.emit();
  }
}
